import { VelavuRule } from "velavu-js-api";

export function doesRuleContainConfig(rule: VelavuRule): boolean {
	return rule.action.config !== undefined;
}
